import { Market } from '../types/Market';

const API_URL = process.env.REACT_APP_API_URL || '/api';

export const MarketService = {
  // Get all markets
  getAllMarkets: async (): Promise<Market[]> => {
    try {
      const response = await fetch(`${API_URL}/markets`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(localStorage.getItem('token') && { 'Authorization': `Bearer ${localStorage.getItem('token')}` })
        },
        mode: 'cors'
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Failed to fetch markets:', error);
      throw error;
    }
  },
  
  // Get a single market by ID
  getMarketById: async (id: number): Promise<Market> => {
    try {
      const response = await fetch(`${API_URL}/markets/${id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(localStorage.getItem('token') && { 'Authorization': `Bearer ${localStorage.getItem('token')}` })
        },
        mode: 'cors'
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error(`Failed to fetch market with ID ${id}:`, error);
      throw error;
    }
  },
  
  // Create a new market
  createMarket: async (market: Market): Promise<Market> => {
    try {
      const response = await fetch(`${API_URL}/markets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(localStorage.getItem('token') && { 'Authorization': `Bearer ${localStorage.getItem('token')}` })
        },
        mode: 'cors',
        body: JSON.stringify(market)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error('Failed to create market:', error);
      throw error;
    }
  },
  
  // Update an existing market
  updateMarket: async (id: number, market: Market): Promise<Market> => {
    try {
      const response = await fetch(`${API_URL}/markets/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(localStorage.getItem('token') && { 'Authorization': `Bearer ${localStorage.getItem('token')}` })
        },
        mode: 'cors',
        body: JSON.stringify(market)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      return data.data;
    } catch (error) {
      console.error(`Failed to update market with ID ${id}:`, error);
      throw error;
    }
  },
  
  // Delete a market
  deleteMarket: async (id: number): Promise<void> => {
    try {
      const response = await fetch(`${API_URL}/markets/${id}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          ...(localStorage.getItem('token') && { 'Authorization': `Bearer ${localStorage.getItem('token')}` })
        },
        mode: 'cors'
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Error ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error(`Failed to delete market with ID ${id}:`, error);
      throw error;
    }
  }
};

export default MarketService; 